import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import CommonCardHeader from '../../Utils/CommonComponents/CommonCardHeader'
import { ApexOptions } from 'apexcharts'

interface ColumnChartProps {
    title: string;
    data: {
        series: { name: string; data: number[] }[];
        name?: string;
        categories: string[];
        si_unit: string;
    };
    height?: number;
    width?: number;
    size?: number;
}

const EnergyColumnChart = ({ title, data, height, width, size = 6 }: ColumnChartProps) => {
    var columnChart: ApexOptions = {
        chart: {
            height: height ?? 350,
            type: 'bar',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        // series: data.series.map(series => series.data),
        series: data.series,
        xaxis: {
            categories: data.categories,
        },
        yaxis: {
            title: {
                text: data.si_unit
            }
        },
        fill: {
            opacity: 1
    
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    // return "$ " + val + " thousands"
                    return `${val} ${data.si_unit}`
                }
            }
        },
        colors: ['#e9622c','#308e87', '#f39159', '#51bb25'],
        legend: {
            show: true,
            labels: {
                colors: '#ffffff'
            }
        },
    }
    return (
        <Col sm={12} xl={size} className={`box-col-${size}`}>
            <Card style={{ width: '100%' }}>
                {/* <CommonCardHeader title={title} /> */}
                <CardBody>
                    <div id="column-chart" style={{ width: '100%' }}>
                        <ReactApexChart options={columnChart} series={columnChart.series} type="bar" height={height ?? 350} width={width ?? 400}/>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}

export default EnergyColumnChart;
